import BaseApi from '@/services/api/base.api'

class VerificationApi extends BaseApi {
  /**
   * @description 본인인증 key가져오는 ep
   * @swagger https://artist-aggregator.dev.id-us.me/docs/webjars/swagger-ui/index.html?urls.primaryName=%F0%9F%94%8E%20Default%20(%EC%A0%84%EC%B2%B4)#/%EB%B3%B8%EC%9D%B8%EC%9D%B8%EC%A6%9D/request
   */
  async selectVerificationKey(): Promise<IAuthVerificationKeySelect.Response> {
    return await this.app.$fetchService.post(
      `${this.artistAggregatorBaseUrl}/api/v1/identity-verification/korea-pass`,
    )
  }
}

export default VerificationApi
